import { API_BASE } from "../env.js";

export interface MeResponse {
  ok: boolean;
  email?: string;
  exp?: number;
  code?: string;
}

export async function fetchMe(): Promise<MeResponse> {
  try {
    const res = await fetch(`${API_BASE}/api/me`, {
      credentials: "include"
    });
    if (res.status === 401) return { ok: false, code: "UNAUTH" };
    const json = (await res.json()) as MeResponse;
    return json;
  } catch {
    return { ok: false, code: "NETWORK" };
  }
}

export interface SendMagicLinkResponse {
  ok: boolean;
  message?: string;
  code?: string;
}

export async function sendMagicLinkEmail(email: string): Promise<SendMagicLinkResponse> {
  try {
    const res = await fetch(`${API_BASE}/api/auth/email`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email })
    });
    const json = (await res.json()) as SendMagicLinkResponse;
    return json;
  } catch {
    return { ok: false, code: "NETWORK", message: "Network error. Try again." };
  }
}

export async function signOut(): Promise<{ ok: boolean }> {
  try {
    const res = await fetch(`${API_BASE}/api/auth/logout`, {
      method: "POST",
      credentials: "include"
    });
    return { ok: res.ok };
  } catch {
    return { ok: false };
  }
}
